import React from 'react';
import { Box, Typography } from '@mui/material';
import { FONT_ENUM } from '../../types/global/fonts.types';
import { formatUnreadBadgeCount, normalizeUnreadCount } from '../../utils/campaignThreadUnread';

export interface CampaignThreadUnreadBadgeProps {
    count?: number | null;
    /** sm = avatar dot; md = inline pill */
    size?: 'sm' | 'md';
    /** When true, positions absolutely for avatar overlays */
    overlay?: boolean;
}

export function CampaignThreadUnreadBadge({ count, size = 'md', overlay = false }: CampaignThreadUnreadBadgeProps) {
    const normalized = normalizeUnreadCount(count);
    const label = formatUnreadBadgeCount(normalized);
    if (!label) return null;

    const isSmall = size === 'sm';

    return (
        <Box
            role="status"
            aria-label={`${normalized} unread message${normalized === 1 ? '' : 's'}`}
            sx={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                minWidth: isSmall ? 18 : 22,
                height: isSmall ? 18 : 22,
                px: isSmall ? 0.5 : 0.75,
                borderRadius: 999,
                bgcolor: '#ff4757',
                color: '#fff',
                border: '2px solid rgba(14,14,14,0.95)',
                boxShadow: '0 0 0 1px rgba(255,71,87,0.35)',
                ...(overlay
                    ? {
                          position: 'absolute',
                          top: isSmall ? -4 : -6,
                          right: isSmall ? -4 : -6,
                          zIndex: 2,
                      }
                    : {}),
            }}>
            <Typography
                sx={{
                    fontFamily: FONT_ENUM.MAIN_BOLD,
                    fontSize: isSmall ? 9 : 10,
                    lineHeight: 1,
                    fontWeight: 800,
                }}>
                {label}
            </Typography>
        </Box>
    );
}
